let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1hxuP")).then(() => parcelRequire('4BRVO'));